import axios from "../axios";

const getDepositHistory = async function (accessToken, params = {}) {
    try {
        const response = await axios.post('deposit/getDepositHistory', params, {
            headers: {
                'Authorization': accessToken
            },
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status,
            message: e.response.data.message
        }
    }
}

export default getDepositHistory; 
